import React from "react";
import PaymentOptions from "./PaymentOptions";
import { Container } from "react-bootstrap";
import { motion } from "framer-motion";
import "./Payments.css";

const Payments = () => {
  return (
    <div className="payments-page-container">
      <div className="payments-bg"></div>
      <Container>
        <motion.div 
          className="center-title_wrapper"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="tag-component">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
              <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
              <path d="M18 12a2 2 0 0 0 0 4h4v-4Z" />
            </svg>
            SECURE CHECKOUT
          </div>
          
          <h2 className="payments-heading">
            <span className="text-gradient-orange">FTunes &ndash;</span><br />
            Payment <span className="text-gradient-pink">Options</span>
          </h2>
          
          <p className="payments-description">
            Complete your purchase securely. Choose from our various payment plans below.
          </p>
        </motion.div>

        <motion.div
          className="payments-content-wrapper"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <PaymentOptions />
        </motion.div>
      </Container>
    </div>
  );
};

export default Payments;
